const prefix = 'sbt-caravanas-';

export const localStorageSetItem = (keyname, object) => {
  const string = JSON.stringify(object)
  localStorage.setItem( `${prefix}${keyname}`, string);
}

export const localStorageGetItem = (keyname) => {
  try {
    return JSON.parse(localStorage.getItem(`${prefix}${keyname}`))
  } catch (e) {
    return null
  }
}